<template>
  <Header/>
  <Index/>
  <div class="blockFoot"></div>
  <Foot/>
</template>

<script>
import Header from '@/components/Header.vue'
import Foot from '@/components/foot.vue'
import Index from '@/views/index.vue'

export default {
  name: 'HomeView',
  components: {
    Header, Foot, Index
  },
  mounted() {
    document.title = "Hyperinsight-寻找优质聪明钱";
  }
}
</script>
<style lang="less" scoped>
  .blockFoot{
      width: 100%;
      height: 125px;
      background: #121212;
  }
  html,body{
      background-color: #121212;
  }
</style>
